<template>
  <Panel
    lineColor="var(--primary-color)"
    class="rfm-panel"
    id="card-configuracao-geral"
  >
    <div class="section-header">
      <div>
        <h3 class="section-title">Configuração geral</h3>
        <p class="section-subtitle">
          Defina o período histórico de análise e o status operacional da Matriz
          RFM.
        </p>
      </div>
      <div class="rfm-status-atual">
        <span class="rfm-status-label">Status do motor:</span>
        <Chip
          :color="config.ativa ? 'green' : 'orange'"
          :text="config.ativa ? 'Ativa' : 'Inativa'"
          small
        />
      </div>
    </div>

    <v-row>
      <v-col cols="12" md="6">
        <label class="field-label">Período de análise</label>
        <div class="rfm-periodo-opcoes">
          <FormButton
            v-for="meses in periodos"
            :key="`periodo-${meses}`"
            :id="`btn-periodo-${meses}-meses`"
            type="primario"
            color="primario"
            :outlined="config.periodo_analise !== meses"
            :text="`${meses} meses`"
            @click="$emit('alterar', { periodo_analise: meses })"
          />
        </div>
        <small class="field-hint">
          Período histórico usado para calcular Frequência e Valor Monetário dos
          clientes.
        </small>
      </v-col>

      <v-col cols="12" md="6">
        <label class="field-label">Status da Matriz RFM</label>
        <FormSwitch
          id="switch-status-matriz"
          :value="config.ativa"
          :label="config.ativa ? 'Ativa' : 'Inativa'"
          @change="valor => $emit('alterar', { ativa: !!valor })"
        />
        <small class="field-hint">
          Quando inativa, as configurações permanecem salvas, mas o
          processamento RFM não é realizado.
        </small>
      </v-col>
    </v-row>

    <p v-if="ultimaExecucao" class="rfm-ultima-execucao">
      Última execução do processamento: <strong>{{ ultimaExecucao }}</strong>
    </p>
  </Panel>
</template>

<script>
import Panel from "@/components/Panel";
import FormButton from "@/components/form/FormButton";
import FormSwitch from "@/components/form/FormSwitch";
import Chip from "@/components/Chip";
import { PERIODOS_ANALISE } from "@/utils/rfm-faixas";

export default {
  name: "MatrizRfmGeral",
  components: { Panel, FormButton, FormSwitch, Chip },
  props: {
    config: { type: Object, required: true },
    ultimaExecucao: { type: String, default: "" }
  },
  data: () => ({
    periodos: PERIODOS_ANALISE
  })
};
</script>

<style scoped>
.rfm-panel {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.section-title,
.section-subtitle,
.field-label,
.field-hint,
.rfm-ultima-execucao {
  text-align: left;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.section-subtitle {
  color: #6a6c6f;
  font-size: 16px;
  margin-bottom: 16px;
}

.rfm-periodo-opcoes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.rfm-status-atual {
  display: flex;
  align-items: center;
  gap: 4px;
}

.rfm-status-label {
  color: #6a6c6f;
}

.field-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
}

.field-hint {
  display: block;
  color: #6a6c6f;
}

.rfm-ultima-execucao {
  color: #6a6c6f;
  margin: 12px 0 0;
}
</style>
